// syncronous, gaan we gebruiken om variabelen te setten
import GARAGE_MUTATION_TYPES from './garage.mutation-types';

const GARAGE_MUTATIONS = {
  [GARAGE_MUTATION_TYPES.SET_ERROR](state, error) {
    state.status.error = error;
  },
  [GARAGE_MUTATION_TYPES.APPEND_GARAGES](state, garages) {
    state.garages = garages;
  },
  [GARAGE_MUTATION_TYPES.APPEND_GARAGE_SEARCH_RESULTS](state, garages) {
    state.garageSearchResults = garages;
  },
  [GARAGE_MUTATION_TYPES.APPEND_TIRECODES](state, tireCodes) {
    state.tireCodes = tireCodes;
  },
};

export default GARAGE_MUTATIONS;
